'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote(text, name, role) {
  this.i6 = null;
  this.i4 = null;
  this.i5 = null;
  this.i6 = text;
  this.i4 = name;
  this.i5 = role;
}
export { $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote as $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote };
$p = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote() {
}
export { $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote as $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote };
$h_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 134336448, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote) && (((this.i6 === x$0.i6) && (this.i4 === x$0.i4)) && (this.i5 === x$0.i5))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "Quote";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.i6;
      break;
    }
    case 1: {
      return this.i4;
      break;
    }
    case 2: {
      return this.i5;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bs)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote as $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote };
var $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote, "io.intela.sites.digitalinternship.data.CaseStudies$Quote", ({
  bs: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote as $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Quote };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Case-Studies$-Quote.js.map
